import React from 'react'
import moment from 'moment'

import bwLogo from '../logo_color_print.jpg'
import * as organization from '../services/organization-service'
export default class PrintExtendedHeader extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.getLogo = this.getLogo.bind(this)
    this.state = { 
      orgLogo: "",
    }
  }

  componentDidMount() {
    this.getLogo()
  }
  
  getLogo() {
    organization.getLogo().then((logo) => this.setState({orgLogo: logo}))
  }

  printHeader() {
    const {scan, originalScan, currentUnit} = this.props

    return (
      <div className="scan-container">
        { this.props.type === "results" &&
          <React.Fragment>
            <h2>Resultaten</h2>
            { this.props.currentUnit &&
              <React.Fragment>
                <p style={{fontSize: '15px', fontStyle: 'italic', lineHeight: '1.4em', marginBottom: '0'}}><span style={{fontWeight: 'bold'}}>Locatie: </span>{currentUnit.locationName}</p>
                <p style={{fontSize: '15px', fontStyle: 'italic', lineHeight: '1.4em', marginBottom: '1em'}}><span style={{fontWeight: 'bold'}}>Organisatorische eenheid: </span>{currentUnit.name}</p>
              </React.Fragment>
            }
            <p style={{fontSize: '15px', lineHeight: '1.3em', marginBottom: '2em'}}>Ingevuld op: {moment(scan.completedDate).format('DD-MM-YYYY')}</p>
          </React.Fragment>
        }
        { this.props.type === "extraQuestions" &&
          <React.Fragment>
            <h2>Extra vragen</h2>
            { this.props.currentUnit &&
              <React.Fragment>
                <p style={{fontSize: '15px', fontStyle: 'italic', lineHeight: '1.4em', marginBottom: '0'}}><span style={{fontWeight: 'bold'}}>Locatie: </span>{currentUnit.locationName}</p>
                <p style={{fontSize: '15px', fontStyle: 'italic', lineHeight: '1.4em', marginBottom: '1em'}}><span style={{fontWeight: 'bold'}}>Organisatorische eenheid: </span>{currentUnit.name}</p>
              </React.Fragment>
            }
          </React.Fragment>
        }
        { this.props.type === "analysis" &&
          <React.Fragment>
            <h2>Analyse</h2>
            { this.props.currentUnit &&
              <React.Fragment>
                <p style={{fontSize: '15px', fontStyle: 'italic', lineHeight: '1.4em', marginBottom: '0'}}><span style={{fontWeight: 'bold'}}>Locatie: </span>{currentUnit.locationName}</p>
                <p style={{fontSize: '15px', fontStyle: 'italic', lineHeight: '1.4em', marginBottom: '1em'}}><span style={{fontWeight: 'bold'}}>Organisatorische eenheid: </span>{currentUnit.name}</p>
              </React.Fragment>
            }
            <div className="filled-in">
              <p style={{fontSize: '15px', lineHeight: '1.3em', marginBottom: '0'}}>Scan ingevuld op: {moment(originalScan.completedDate).format('DD-MM-YYYY')}</p>
              <p style={{fontSize: '15px', lineHeight: '1.3em', marginBottom: '2em'}}>Analyse ingevuld op: {moment(scan.completedDate).format('DD-MM-YYYY')}</p>
            </div>
          </React.Fragment>
        }
      </div>
    )
  }

  render() {
    //TODO get the proper contenttype png or jpeg, (png seems to work even for jpeg's so this is ok for now)
    const orgLogo = 'data:image/png;base64,' + this.state.orgLogo

    return (
      <React.Fragment>
        <div className="print-logo-container">
          <div className="bw-logo"><img src={bwLogo} alt={"bwlogo"} style={{height: 'auto', width: '140px'}}/></div>
          <div className="organisation-logo"><img src={orgLogo} alt={"orglogo"} style={{float: 'right', height: 'auto', width: '140px'}}/></div>
        </div>
        <div className="print-question-header">
          {this.printHeader()}
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PrintExtendedHeader.js